import { isAuthenticated, useAuthStore } from '@/stores/authStore';
import { useMainStore } from '@/stores/mainStore';
import { useUserStore } from '@/stores/userStore';
import { useGmApi } from './useGmApi';

export function useAuth() {
  const authStore = useAuthStore();
  const mainStore = useMainStore();
  const userStore = useUserStore();
  const { logout } = useGmApi();

  async function resetLocalState() {
    authStore.unsetToken();
    mainStore.unsetTeamTwrn();
    mainStore.unsetOrgTwrn();
    userStore.unsetUser();
    userStore.unsetImpersonator();
  }

  async function logOut() {
    try {
      if (isAuthenticated()) {
        await logout();
      }
    } catch (error) {
      console.error('Error logging out', error);
    } finally {
      resetLocalState();
    }
  }

  return {
    logOut,
  };
}
